import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { FiShield, FiArrowRight } from "react-icons/fi"

export default function VerifyCertificatePage() {
  const navigate    = useNavigate()
  const [credId, setCredId] = useState("")

  const handleSubmit = (e) => {
    e.preventDefault()
    const id = credId.trim()
    if (id) navigate(`/certificate/${id}`)
  }

  return (
    <div className="flex min-h-[calc(100vh-3.5rem)] items-center justify-center px-4 py-20">
      <div className="w-full max-w-lg">
        {/* Icon */}
        <div className="mb-6 flex justify-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-2xl border border-caribbeangreen-300/30 bg-caribbeangreen-300/10">
            <FiShield className="text-3xl text-caribbeangreen-300" />
          </div>
        </div>

        {/* Heading */}
        <h1 className="mb-2 text-center text-3xl font-bold text-richblack-5">
          Verify Certificate
        </h1>
        <p className="mb-8 text-center text-sm text-richblack-400">
          Enter a KodeVedic credential ID to instantly verify the authenticity
          of any certificate issued on our platform.
        </p>

        {/* Form */}
        <form onSubmit={handleSubmit} className="flex flex-col gap-3 sm:flex-row">
          <input
            type="text"
            value={credId}
            onChange={(e) => setCredId(e.target.value)}
            placeholder="e.g. KV-2025-00001-REACT"
            className="flex-1 rounded-xl border border-richblack-600 bg-richblack-700 px-4 py-3 text-sm text-richblack-5 placeholder-richblack-400 outline-none transition-colors focus:border-caribbeangreen-300"
          />
          <button
            type="submit"
            disabled={!credId.trim()}
            className="flex items-center justify-center gap-2 rounded-xl bg-caribbeangreen-300 px-6 py-3 text-sm font-semibold text-richblack-900 transition-all hover:bg-caribbeangreen-200 active:scale-95 disabled:cursor-not-allowed disabled:opacity-50"
          >
            Verify <FiArrowRight />
          </button>
        </form>

        {/* Hint */}
        <p className="mt-4 text-center text-xs text-richblack-500">
          The credential ID can be found at the bottom of your certificate (e.g.{" "}
          <span className="font-mono text-richblack-400">KV-2025-00001-REACT</span>).
        </p>
      </div>
    </div>
  )
}
